import { BrowserUtils, Configuration, PublicClientApplication, SilentRequest } from '@azure/msal-browser';

import { VersionInfo } from '../../../Config';
import { isBedBoardIntakeForm } from '../helpers';

// For a full list of msal.js configuration parameters visit
// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md

const getSystemConfig = () => {
    /*
    return {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },

            piiLoggingEnabled: true,
        },
    };
    */

    return null;
};

export const msalConfig: Configuration = {
    auth: {
        authority: process.env.REACT_APP_MS_AUTHORITY,
        clientId: process.env.REACT_APP_MS_CLIENTID,
        redirectUri: window.location.origin,
        onRedirectNavigate: () => !BrowserUtils.isInIframe(),
    },

    cache: {
        cacheLocation: 'localStorage', // This configures where your cache will be stored
    },

    system: {
        ...getSystemConfig(),
        allowPlatformBroker: false, // Disables WAM Broker
    },

    telemetry: {
        application: {
            appName: 'MedOne Post-Acute',
            appVersion: VersionInfo.AppVersion,
        },
    },
};

// Coordinates and required scopes for your web api
export const apiConfig = {
    // Enter the API scopes as declared in the app registration 'Expose an Api' blade in the form of 'api://{client_id}/.default'
    resourceScope: process.env.REACT_APP_MS_SCOPES,
};

/**
 * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters,
 * visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
 */
export const loginRequest = {
    scopes: ['openid', 'profile', 'offline_access'],
    redirectUri: `${window.location.origin}`,
};

// Add here scopes for access token to be used at the API endpoints.
export const tokenRequest = {
    scopes: [apiConfig.resourceScope],
    redirectUri: `${window.location.origin}`,
};

// Add here scopes for silent token request
export const silentRequest = {
    scopes: ['openid', 'profile', apiConfig.resourceScope],
    redirectUri: `${window.location.origin}`,
} as SilentRequest;

export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

export const msalInstance = new PublicClientApplication(msalConfig);

let forceRefresh = true;

export const acquireAccessToken = async (refresh = false) => {
    // Don't try to get token during public intake form requests
    if (isBedBoardIntakeForm()) {
        return Promise.resolve('');
    }

    if (refresh) {
        forceRefresh = true;
    }

    // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
    const activeAccount = msalInstance.getActiveAccount();
    const accounts = msalInstance.getAllAccounts();

    if (!activeAccount && accounts.length === 0) {
        await msalInstance.loginRedirect(loginRequest);

        return '';
    }

    const request = {
        ...silentRequest,
        account: activeAccount || accounts[0],
        forceRefresh: forceRefresh,
    } as SilentRequest;

    try {
        forceRefresh = false;

        const authResult = await msalInstance.acquireTokenSilent(request);

        return authResult.accessToken;
    } catch (error: any) {
        await msalInstance.loginRedirect(loginRequest);
    }
};
